export default __webpack_public_path__ + "static/media/profile-1.1b1df8c8.JPG";